import { Grid2, Stack, Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { SealIcon } from "../../../components/seal-icon";
import "./styles.scss";
import EastIcon from "@mui/icons-material/East";

export const HomePageUserTypeBlock = ({
  title,
  description,
  to,
  linkText,
  size = {
    xs: 2,
    md: 1,
  },
}: {
  title: string;
  description: string;
  to?: string;
  linkText?: string;
  size?: any;
}) => {
  return (
    <Grid2 className="user-type-block text-center" size={size}>
      <Stack alignItems="center" justifyContent="space-around" height="100%">
        <div className="seal-icon">
          <SealIcon />
        </div>
        <Typography variant="h6" className="title">
          {title}
        </Typography>
        <Typography
          sx={{
            mb: "24px",
          }}
          variant="body1"
          className="description text-contain font-size-3"
        >
          {description}
        </Typography>
        {to && (
          <Button
            size="large"
            className="c2a"
            variant="outlined"
            endIcon={<EastIcon />}
            component={Link}
            to={to}
          >
            <span className="font-size-3">{linkText}</span>
          </Button>
        )}
      </Stack>
    </Grid2>
  );
};
